import { generateUuid, get, regFace, DebugEnv } from '@chat/utils';
import {
    faqappend,
    faqchangeStatus,
    faqWorkflowsRun,
    getfaq
} from '@/redux/faq/action';
import {
    imappend,
    setstage,
    imnotice,
    imwakeup,
    setchatstatus,
    setCount,
    setLast,
    imsend,
    setLastTime,
    editCollect
} from '@/redux/im/action';
import store from '@/redux/index';
import { IM_PULL } from '@/api/url';
import { IMServerImp, IM_CTX, IM_MESSAGE, IM_SEND_OPTIONS } from '@/typings/global';
import { IMSTATUS, IMSTATUS_NAME, MSGTYPE, MsgType } from '@/config/enum';
import { PAYLOAD_STATUS, PAYLOAD_WAKEUP } from '@/typings/payload';
import { outline } from '@/helpers/online';
import reportTimeout from '@/utils/reportTimeout';
import encrypt from '@/utils/encryptor';

const { dispatch, getState } = store;

class IMServer implements IMServerImp {
    /** 轮询间隔 */
    private delay: number;

    private timer: NodeJS.Timeout;

    /**  当前聊天状态 */
    private _processingSwitch: (data: IM_MESSAGE[]) => void;

    /** 通知控制 */
    private _noticeSwitch: (__t: MsgType) => void;

    /** 时间及队列控制 */
    private _pull: ({ loop, once }: { loop?: () => void; once?: number }) => void;

    constructor() {
        this.delay = 10;
        this.timer = null;
        this._processingSwitch = (data) => {
            const { stage } = getState().IMReducer;
            const { can_faq } = getState().FaqReducer;
            // 排队时是追加阶段
            if (_.find(data, { type: MSGTYPE.WAITING_QUEUE })) {
                if (stage !== 1) {
                    setstage(1)(dispatch);
                }
            } else if (stage !== 2) {
                setstage(2)(dispatch);
            }
            // 接入人工取消faq功能
            if (!_.find(data, { type: MSGTYPE.WAITING_QUEUE })) {
                if (can_faq) {
                    faqchangeStatus(false)(dispatch);
                }
            }
        };

        this._noticeSwitch = (__t) => {
            const { STATUS } = getState().IMReducer;
            if (__t === MSGTYPE.TIMEOUT_SYSTEM && !STATUS.EVALUATED) {
                IM.handlePopup({ popup: 'evaluate', open: true });
            }
            if (__t === MSGTYPE.NOGM) {
                setstage(0)(dispatch);
            }
            switch (__t) {
                case MSGTYPE.EVALUATED:
                    IM.handlePopup({ popup: 'evaluate', open: false });
                    setchatstatus({ name: IMSTATUS_NAME.EVALUATED, value: 1 })(dispatch);
                    break;

                case MSGTYPE.COMMENTED:
                    setchatstatus({ name: IMSTATUS_NAME.COMMENTED, value: 1 })(dispatch);
                    // 留言时不进入人工
                    setstage(0)(dispatch);
                    break;
                case MSGTYPE.EVALUATE_INVITE:
                    IM.handlePopup({ popup: 'evaluate', open: true });
                    break;
                case MSGTYPE.CLOSE_BY_GM:
                case MSGTYPE.CLOSE_BY_AUTO_GM:
                case MSGTYPE.CLOSE_BY_USER:
                case MSGTYPE.CLOSE_BY_USER_LEFT:
                case MSGTYPE.TIMEOUT_SYSTEM:
                case MSGTYPE.KICKED:
                case MSGTYPE.NOGM:
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    setchatstatus({ name: IMSTATUS_NAME.status, value: IMSTATUS.ENDED })(dispatch);
                    setchatstatus({ name: IMSTATUS_NAME.CLOSED, value: 1 })(dispatch);
                    break;
                case MSGTYPE.ASSIGNED:
                    setchatstatus({ name: IMSTATUS_NAME.status, value: IMSTATUS.PROCESSING })(
                        dispatch
                    );
                    break;
                case MSGTYPE.TRANSFERED:
                case MSGTYPE.NOTICE:
                default:
                    break;
            }
        };

        this._pull = async ({ loop, once = 0 }) => {
            try {
                const { last_id, platform_id, count, prefix } = getState().IMReducer;
                const _data = {
                    l: last_id,
                    u: platform_id,
                    c: count
                };
                const res = await get(IM_PULL(prefix), _data);
                setCount()(dispatch);
                const { last_time } = getState().IMReducer;
                const data = res.data.d;
                this._processingSwitch(data);
                if (!_.isEmpty(data)) {
                    const dataHasTime = _.filter(data, (item) => !!item?.time);
                    if (!_.isEmpty(dataHasTime)) {
                        await setLastTime({
                            now: dataHasTime[0].time,
                            last_time,
                            compare: 'delay'
                        })(dispatch);
                    }
                }
                this.lists(data);
            } finally {
                if (!once && loop) {
                    loop();
                }
            }
        };
    }

    checkSessionBeforeSend = (type = 1, html: string): boolean => {
        const { STATUS } = getState().IMReducer;
        if (!this.isReady()) return true;
        if (STATUS.CLOSED || DebugEnv.isClose()) {
            IM.IMServer.notice(
                'warn',
                '会话已经结束，如需继续咨询请<span class="win-reload">重新连接客服</span>'
            );
            return true;
        }
        const isOutline = outline(type, html);
        return isOutline;
    };

    send = async (
        html: string,
        file: File,
        beforeCallback: (htmlReg: string, faceReg: string) => Promise<boolean>,
        afterCallback: (htmlReg: string, faceReg: string) => void,
        options?: IM_SEND_OPTIONS
    ): Promise<void> => {
        const { stage } = getState().IMReducer;
        const {
            base_config: { faq_unique_id }
        } = getState().IndexReducer;
        const {
            base_config: { faq_switch }
        } = getState().IndexReducer;
        const { request_type } = getState().FaqReducer;

        if (file && (faq_switch === 0 || stage === 2)) {
            await imsend({ m: file, type: 'upload_image' })(dispatch, getState);
            return;
        }
        const _htmlReg = IM.EditorServer.funcContent(html);
        const _faceReg = regFace(_htmlReg);
        if (beforeCallback) {
            const next = await beforeCallback(_htmlReg, _faceReg);
            if (!next) {
                return;
            }
        }
        const customMessage = options?.custom
            ? `[ssbq_custom_card_msg=${JSON.stringify(options.custom)}]`
            : '';
        if (customMessage) {
            console.log('send custom message', customMessage);
        }

        const messageToSend = customMessage || _faceReg;

        // 没有faq的游戏任何阶段都是将消息发送给队列
        if (faq_switch === 0 || stage === 2) {
            await imsend({
                m: messageToSend
            })(dispatch, getState);
            return;
        }

        // 根据 FAQ 请求类型决定走关键词匹配、AI 工作流或组合请求
        // @ts-ignore
        if (stage !== 2) {
            await IM.DifyServer.abortWorkflow();

            const faqMessageId = generateUuid(8, 16);
            await faqappend({
                message: options?.custom || _htmlReg,
                type: 'out',
                id: faqMessageId,
                ...(options?.custom && { msg_type: 'ssbq_custom_card_msg' as const })
            })(dispatch, getState);

            // 全部AI 或者 组合请求 先走 FAQ，再根据后端 request_dify 返回决定是否触发 Dify 工作流
            if (request_type === 3 || request_type === 2) {
                const faqResult = (await getfaq(messageToSend, {
                    dify: 1,
                    checkRequestDify: true,
                    messageId: faqMessageId
                })(dispatch, getState)) as {
                    input: string;
                    context: string;
                    token: string;
                    request_dify?: boolean;
                    // 1 表示需要上报
                    report_dify_result?: 0 | 1;
                };
                if (faqResult?.request_dify === true) {
                    await faqWorkflowsRun(
                        faqResult.input || messageToSend,
                        faqResult.report_dify_result || 0,
                        faqMessageId,
                        faqResult.context,
                        faqResult.token
                    )(dispatch, getState);
                }
                return;
            }

            // 其余情况统一走 FAQ，作为 request_type 缺省时的兜底路径
            await getfaq(messageToSend, { messageId: faqMessageId })(dispatch, getState);
        }
        if (afterCallback) {
            afterCallback(_htmlReg, _faceReg);
        }
    };

    notice = (type: MsgType, message: string): void => {
        imnotice(type, message)(dispatch);
    };

    lists = (list: IM_MESSAGE[] = []): void | boolean => {
        const len = list.length;
        if (len <= 0) {
            return false;
        }
        for (let i = 0; i < len; i++) {
            const { last_id } = getState().IMReducer;
            const item = list[i];
            const type = item.type || 'in';
            const __t = item.__t || type;
            const _append = () => {
                this._noticeSwitch(__t);
                imappend({ ...item, __t })(dispatch, getState);
            };
            if (item.id) {
                if (last_id < item.id) {
                    setLast({ last_id: item.id })(dispatch);
                    _append();
                }
            } else {
                _append();
            }
        }
    };

    pull = (once: 0 | 1): void => {
        this._pull({ once });
    };

    iswakeup = ({ actived, started }: PAYLOAD_WAKEUP): void => {
        imwakeup({ actived, started })(dispatch);
    };

    loop = (): void => {
        const { actived, STATUS } = getState().IMReducer;
        if (actived && STATUS.status !== IMSTATUS.ENDED && STATUS.status !== IMSTATUS.INITAIZLIED) {
            this.timer = setTimeout(() => {
                this._pull({ loop: this.loop });
            }, this.delay);
        }
    };

    lockPage = (): void => {
        this.iswakeup({ actived: 0, started: 0 });
    };

    isReady = (): boolean => {
        const { actived } = getState().IMReducer;
        const swiper = {
            0: () => alert('页面还没准备好呢，请稍等哦～'),
            1: () => {},
            2: () => alert('页面初始化失败，请刷新重试哦～')
        };
        swiper[actived]();
        return actived === 1;
    };

    reconnect = (): void => {
        window.location.reload();
    };

    windowReload = (): void => {
        $(window).on('beforeunload', () => {
            const { STATUS, stage } = getState().IMReducer;
            if (stage === 0) {
                return undefined;
            }
            if (STATUS.CLOSED) {
                return undefined;
            }
            if (STATUS.EVALUATED) {
                return '您确认要结束对话？';
            }
            if (STATUS.status === IMSTATUS.INITAIZLIED) {
                return '您确认要结束对话？';
            }
            if (STATUS.status >= IMSTATUS.PROCESSING) {
                return '为更好地提升服务质量，请对我们的服务进行评价。\n请点击【留在此页】，继续评价操作。谢谢！';
            }
        });
        $(window).on('unload', () => {
            const { STATUS } = getState().IMReducer;
            if (STATUS.CLOSED) {
                return;
            }
            IM.SDKServer.closeByWindow(1);
        });
    };

    removeListener = (): void => {
        $(window).off('beforeunload');
        $(window).off('unload');
    };

    changeChatStatus = ({ name, value }: PAYLOAD_STATUS): void => {
        setchatstatus({ name, value })(dispatch);
    };

    noticeSwitch = (__t: MsgType): void => {
        this._noticeSwitch(__t);
    };

    editCollect = async ({
        collect_type,
        fields
    }: {
        collect_type: number;
        fields: Record<string, string>;
    }): Promise<void> => {
        await editCollect({ collect_type, fields })(dispatch, getState);
    };
}
export default IMServer;
